import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import PriceCheckOutlinedIcon from '@mui/icons-material/PriceCheckOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { BottomNavigation, BottomNavigationAction, useTheme } from '@mui/material';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../routes/routes';

export const BottomNavigator = () => {
  const theme = useTheme();
  const location = useLocation();
  const [value, setValue] = useState(location.pathname || '/inicio');
  const navigate = useNavigate();

  const handleNavigate = (newValue: string) => {
    setValue(newValue);
    navigate(newValue);
  };

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        handleNavigate(newValue);
      }}
      showLabels
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        elevation: 10,
        justifyContent: 'center',
        backgroundColor: theme.palette.primary.main,
        '& .MuiBottomNavigationAction-root': {
          color: 'white', // Define a cor dos ícones como branco
          '&.Mui-selected': {
            color: 'white', // Define a cor do ícone ativo como branco
            borderBottom: `2px solid white` // Adiciona uma borda ao ícone ativo
          },
          transform: 'scale(0.9)' // Ajusta o tamanho dos ícones
        },
        '& .MuiBottomNavigationAction-label': {
          whiteSpace: 'nowrap', // Evita quebra de linha nos labels
          color: 'white', // Define a cor dos labels como branco
          '&.Mui-selected': {
            color: 'white', // Define a cor do label ativo como branco
            fontSize: '0.8rem', // Aumenta o tamanho da fonte do label ativo
            fontWeight: 'bold' // Deixa o label ativo em negrito
          }
        }
      }}
    >
      <BottomNavigationAction
        label="Linha do Tempo"
        value={ROUTES.authenticated.dashboard}
        to={ROUTES.authenticated.dashboard}
        icon={<FeedOutlinedIcon />}
        component={Link}
        centerRipple
      />
      <BottomNavigationAction
        label="Folha Pagamento"
        value={ROUTES.authenticated.registers.paymentsheet}
        to={ROUTES.authenticated.registers.paymentsheet}
        icon={<PriceCheckOutlinedIcon />}
        component={Link}
        centerRipple
      />
      <BottomNavigationAction
        label="Espelho Ponto"
        value={ROUTES.authenticated.registers.timesheet}
        to={ROUTES.authenticated.registers.timesheet}
        icon={<AccessTimeIcon />}
        component={Link}
        centerRipple
      />
      <BottomNavigationAction
        label="Código Conduta"
        value={ROUTES.authenticated.registers.codeconduct}
        to={ROUTES.authenticated.registers.codeconduct}
        icon={<PersonOutlineOutlinedIcon />}
        component={Link}
        centerRipple
      />
    </BottomNavigation>
  );
};
